<template>
  <div id="nav">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
@import "assets/scss/styles";
</style>
